export const Config = {
  KEY: 'MOVEMENT',
  ANIMATIONS: {
    WAVE: {
      frames: [0, 1, 2],
      frameRate: 12,
      repeat: 2,
      yoyo: true,
    },
    IDLE: {
      frames: [3, 4],
      frameRate: 12,
      repeat: 0,
    },
    WALK: {
      frames: [5, 6, 7, 8, 9],
      frameRate: 16,
      repeat: -1,
    },
  },
  ATTACHPOINTS: {
    MOUTH: {},
    NECK: {},
  },
};
